import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppState } from '@redux/store'
import { CtaConfiguration, CtaError } from '@typesApp/Cta'
import { configApi } from '@redux/queries/config'

export type CtaState = {
  ctaError: CtaError
  configuration: CtaConfiguration
}

const initialState = {
  ctaError: CtaError.NONE,
} as CtaState

const REDUCER_PATH = 'cta'

export const ctaSlice = createSlice({
  name: REDUCER_PATH,
  initialState: initialState,
  reducers: {
    setCtaError(state, action: PayloadAction<CtaError>) {
      state.ctaError = action.payload
    },
    clearCtaError(state) {
      state.ctaError = CtaError.NONE
    },
    resetCtaInitialState(state) {
      return initialState
    },
  },
  extraReducers: builder => {
    /**
     * Update cta configuration with initial / logged out state
     */
    builder.addMatcher(configApi.endpoints.getCtaInitialConfiguration.matchFulfilled, (state, action) => {
      state.configuration = action.payload
    })

    /**
     * Update cta configuration retaining loggedOut configuration
     */
    builder.addMatcher(configApi.endpoints.getCtaConfiguration.matchFulfilled, (state, action) => {
      state.configuration = {
        ...action.payload,
        loggedOut: state.configuration?.loggedOut,
      }
    })
  },
})

export const { setCtaError, clearCtaError, resetCtaInitialState } = ctaSlice.actions

export const ctaErrorSelector = (state: AppState): CtaError => state.cta.ctaError
export const ctaConfigurationSelector = (state: AppState): CtaConfiguration => state.cta.configuration
